import React from 'react';
import { connect } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';

const EquipmentTypeSelector = ({
  equipTypes,
  equipSubTypes,
  value,
  setValue,
  sortOptions,
  renderOption,
}) => {
  const allTypes = Object.values(equipTypes).concat(Object.values(equipSubTypes));
  return (
    <Autocomplete
      options={Object.values(allTypes).sort(sortOptions)}
      onChange={(_event, newValue) => {
        setValue(newValue.tagName);
      }}
      getOptionLabel={(option) => option?.tagName || option}
      isOptionEqualToValue={(option, v) => option.tagName === v}
      value={value}
      renderOption={renderOption}
      // eslint-disable-next-line react/jsx-props-no-spreading
      renderInput={(params) => <TextField label="Select Equipment Type" {...params} />}
    />
  );
};

export default connect(
  ({
    entities: {
      equipTypes: { byId: equipTypes },
      equipSubTypes: { byId: equipSubTypes },
    },
  }) => ({
    equipTypes,
    equipSubTypes,
  })
)(EquipmentTypeSelector);
